import { useState } from "react";
import "./ui-chatbot.scss";
import { PageBackground } from "./shared";
import { HomeView } from "./homeView";
import { ChatView } from "./chatView";

export const Chatbot = () => {
  const [page, setPage] = useState("home");
  const [inputText, setInputText] = useState("");
  const [initialText, setInitialText] = useState("");
  // Bumped on each New Chat to force ChatView to reset its conversation.
  const [sessionKey, setSessionKey] = useState(0);
  const [sessionId, setSessionId] = useState(null);

  const handleSubmit = () => {
    if (!inputText.trim()) return;
    setInitialText(inputText.trim());
    setInputText("");
    setSessionId(crypto.randomUUID());
    setSessionKey((k) => k + 1);
    setPage("chat");
  };

  const handleNewChat = () => {
    setInputText("");
    setInitialText("");
    setSessionId(null);
    setSessionKey((k) => k + 1);
    setPage("home");
  };

  return (
    <div className="dbs-chatbot">
      <PageBackground />
      {page === "home" ? (
        <HomeView
          inputText={inputText}
          onInputChange={setInputText}
          onSubmit={handleSubmit}
          onNewChat={handleNewChat}
        />
      ) : (
        <ChatView
          key={sessionKey}
          sessionId={sessionId}
          initialText={initialText}
          onNewChat={handleNewChat}
        />
      )}
    </div>
  );
};

export default Chatbot;
